export default __webpack_public_path__ + "static/awareia-158d9d5952b86d97c76c048c83a19991.png";